import { useEffect } from "react";
import Lenis from "lenis";
import Nav from "./Nav";
import Hero from "./Hero";
import Marquee from "./Marquee";
import Manifesto from "./Manifesto";
import Pricing from "./Pricing";
import FinalCTA from "./FinalCTA";
import Footer from "./Footer";

export default function LandingPage() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] text-white antialiased" data-testid="vektor-app">
      <div className="noise-overlay" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Pricing />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
